import { useCallback, useContext, useEffect, useState } from "react";
import { SocketContext } from "../../contexts/SocketContext";
import { AlertContext } from "../../contexts/AlertContext";
import { LoaderContext } from "../../contexts/LoaderContext";

export const useCategories = () => {

    const [categories, setCategories] = useState([]);
    const { socket } = useContext(SocketContext);
    const { alertRef } = useContext(AlertContext);
    const { setOpenLoader } = useContext(LoaderContext);

    useEffect(() => {
        let subscribed = true;

        subscribed && getCategories();

        return () => subscribed = false;
    }, []);

    const getCategories = useCallback(() => {
        setOpenLoader(true);
        socket.emit('frontend:obtener-categorias', response => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef?.current?.handleOpen('error', message);
                return;
            }

            setCategories(data);
            setOpenLoader(false);
        })
    }, []);

	return {
        categories
    }
}